import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chatFilter'
})
export class ChatFilterPipe implements PipeTransform {

  transform(chats: Array<any>, searchBy: any, filterBy: any, userId: any): Array<any> {
    if (searchBy) {
      return chats.filter((x) => (x?.company_name as string).toLocaleLowerCase().includes(searchBy.toLocaleLowerCase()) ||
        (x?.job_name as string).toLocaleLowerCase().includes(searchBy.toLocaleLowerCase())
      );
    }
    if (filterBy == 'unread') {
      return chats.filter((x) => x.unread_count[userId] > 0);
    }
    return chats;
  }
}
